import classNames from "classnames";
import React from "react";

const Main = ({ className, children }) => (
  <div className={classNames("main", className)}>{children}</div>
);

export default Main;
